import { Stroke } from 'ol/style';
import { default as RBaseStyle } from './RBaseStyle';
/**
 * A component for setting the stroke properties of a style
 *
 * Requires an `RStyle` context
 */
class RStroke extends RBaseStyle {
    create(props) {
        this.classProps = RStroke.classProps;
        return new Stroke(props);
    }
    set(ol) {
        if (this.context.style.setStroke)
            return this.context.style.setStroke(ol);
        /* istanbul ignore next */
        throw new Error('Parent element does not support a stroke');
    }
}
RStroke.classProps = ['color', 'width', 'lineCap', 'lineJoin', 'lineDash'];
export default RStroke;
//# sourceMappingURL=RStroke.js.map